<div class="row my-2">
  <div class="col-12">
    @if (entity?.documents?.length) {
      <div>
        @for (document of entity?.documents; track document.id || document.link_file; let i = $index) {
          <div class="d-inline-block mr-1 mb-1">
            @if (document.link_file; as link) {
              <div>
                @if (linkStartsWithBackslash(link)) {
                  <patron-button
                    color="secondary"
                    (click)="downloadAttachmentTeoremaee(document)"
                    [disabled]="tcTicketService.isLoadingDocument(document.ref)"
                    iconName="bi-file-earmark"
                    [loading]="tcTicketService.isLoadingDocument(document.ref)">
                    <span class="ml-1">{{ link | filename }}</span>
                  </patron-button>
                } @else {
                  @if (isValidImageLink(link)) {
                    <img
                      class="rounded img-preview border border-dark"
                      style="max-height: 4vh; width: auto; cursor: pointer"
                      [src]="link"
                      alt="{{ link | filename }}"
                      patron-tooltip="{{ link | filename }}"
                      (click)="openImageModal(link)" />
                  } @else {
                    @if (link.startsWith('http')) {
                      <div>
                        <a
                          class="btn btn-secondary pr-1"
                          role="button"
                          [href]="link"
                          target="_blank">
                          <patron-icon name="bi-file-earmark"></patron-icon>
                          <span class="ml-1">{{ link | filename }}</span>
                        </a>
                      </div>
                    }
                  }
                }
              </div>
            }
          </div>
        }
      </div>
    }

    <patron-file-uploader
      [uploadPath]="uploadPath || ''"
      (saved)="attachmentsSaved($event)"
      (saving)="saving.emit($event)">
    </patron-file-uploader>
  </div>
</div>
<patron-modal
  [visible]="imageModalVisible"
  size="xl"
  [headerTemplate]="headerTemplate"
  [backdrop]="'static'"
  [class]="'image-preview-modal'"
  [headerClass]="'w-100 p-0'"
  [scrollable]="false"
  [showFooter]="false"
  [closeButton]="false"
  (cancel)="closeImageModal()">
  <ng-template #headerTemplate>
    <div
      class="modal-header-wrapper d-flex w-100 justify-content-between align-items-center m-0 p-0">
      <div class="flex-grow-1">
        <span class="pl-2 image-modal-title">{{ selectedImage ?? '' | filename }}</span>
      </div>
      <div class="d-flex align-items-center">
        <patron-button
          customClass="z-index-1 text-primary mr-2"
          variant="ghost"
          iconName="bi bi-window-stack"
          (click)="openInNewTab()"></patron-button>

        <patron-button
          variant="ghost"
          customClass="z-index-1 text-primary"
          iconName="bi bi-x-lg"
          (click)="closeImageModal()"></patron-button>
      </div>
    </div>
  </ng-template>
  <div class="d-flex justify-content-center image-modal-content">
    <img [src]="selectedImage" alt="Imagem ampliada" class="img-fluid" style="max-width: 100%" />
  </div>
</patron-modal>

<style>
  .image-modal-content {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    min-height: 60vh !important;
    max-height: 80vh !important;
    width: 100% !important;
    overflow: auto !important;
    padding: 1rem !important;
    padding-bottom: 2rem !important; /* Add breathing room */
    box-sizing: border-box !important;
  }

  .image-modal-content img {
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain !important;
    display: block !important;
  }

  /* Garante que o modal pai também tenha as dimensões corretas */
  ::ng-deep .p-dialog .p-dialog-content {
    max-height: 80vh !important;
    /* overflow: hidden !important; */
  }

  ::ng-deep .p-dialog {
    max-width: 90vw !important;
    max-height: 90vh !important;
  }

  /* Force header content to full width for flexbox justify-between to work */
  /* Aggressive Reset Strategy to ensure Edge-to-Edge Alignment */

  /* 1. Reset the PrimeNG Header Container */
  ::ng-deep .image-preview-modal .p-dialog-header {
    padding: 0 !important; /* critical: removes default spacing */
    border: none !important;
    display: block !important; /* use block to avoid flex gap issues from parent */
    width: 100% !important;
  }

  /* 2. Force the intermediate wrapper (injected by patron-modal) to fill space */
  ::ng-deep .image-preview-modal .p-dialog-header > div {
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 1rem !important; /* Restore desired padding here, internally */
  }

  ::ng-deep .image-preview-modal .p-dialog-titlebar-icon {
    display: none !important;
  }

  /* 3. The internal wrapper is already w-100 d-flex via classes, but ensure no extra margins */
  ::ng-deep .modal-header-wrapper {
    width: 100% !important;
  }

  /* Fix Double Scrollbar: Disable scrolling on the PrimeNG content wrapper */
  ::ng-deep .image-preview-modal .p-dialog-content {
    overflow: hidden !important; /* Let inner content handle scroll */
    padding: 0 !important; /* Optional: remove padding to maximize space */
    height: auto !important; /* ALLOW auto height to prevent cutoff */
    flex-grow: 1 !important; /* Ensure it fills remaining space */
  }
</style>
